var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module",
    attrs: {
      "id": "chemtracker-sds-attachments-ui"
    }
  }, [_c('Stepper', {
    attrs: {
      "hide-stepper-controls": "",
      "current-step": _vm.currentStep,
      "steps": _vm.getSteps(),
      "step-components": _vm.stepperStepsComponents,
      "step-labels": _vm.stepLabels
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }